export default __webpack_public_path__ + "static/media/guide-bg.25e7564f.png";